import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FabbricatiFormComponent } from './dialogs/form/form.component';
import { FabbricatiComponent } from './fabbricati.component';

const routes: Routes = [
  {
    path: '', component: FabbricatiComponent
  },
  {
    path: 'inserisci', component: FabbricatiFormComponent,
    data: { title: 'Inserimento Fabbricati' },
  },
  { path: ':idFabbricato', loadChildren: () => import('./view/fabbricato-view.module').then(m => m.FabbricatoViewModule) },

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FabbricatiRoutingModule { }
